import { connect } from 'react-redux'

import { setNewsReadTimestamp } from '../actions/newsStatus'

const mapStateToProps = state => ({
  newsReadTimestamp: state.newsStatus.newsReadTimestamp
})

const mapDispatchToProps = dispatch => ({
  setNewsReadTimestamp: timestamp => dispatch(setNewsReadTimestamp(timestamp))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./src/hocs/withNewsStatus.js